export type { IAuthStore, IUserInfo } from './types'
export type { IdpState } from './state'
export { AuthErrorStatus, AuthError } from './types'
import { OktaSvelteStore } from './okta/store'

export { OktaSvelteStore } from './okta/store'
export const useOktaStore = OktaSvelteStore.getInstance